module.exports = __webpack_public_path__ + "img/TH.755ffe34.png";